<template>
  <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper" id="kt_wrapper">
    <Loading v-show="loading"/>
    <!--[html-partial:include:{"file":"partials\/_header-base.html"}]/-->
    <div v-show="!loading"
         class="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
         id="kt_content">
      <div class="kt-container">
        <div class="kt-portlet kt-margin-top-30" id="content-portlet">
          <div class="kt-portlet__head app__portlet-head">
            <div class="kt-portlet__head-label">
              <h3 class="kt-portlet__head-title">
                Настройки приложения
              </h3>
            </div>
          </div>

          <div v-if="criticalErrorsList && criticalErrorsList.length > 0"
               class="kt-portlet__body app_service__form-body">
            <div v-for="error in criticalErrorsList"
                 class="alert alert-warning fade show"
                 role="alert">
              <div class="alert-icon"><i class="flaticon-warning"></i></div>
              <div class="alert-text">{{ error }}</div>
            </div>
          </div>

          <!--begin::Form-->
          <form v-else class="kt-form app_service__form" id="settings-form"
                enctype="multipart/form-data"
                v-on:submit.prevent="saveSettings">

            <template v-if="errorsList">
              <div v-for="error in errorsList"
                   class="alert alert-warning fade show"
                   role="alert">
                <div class="alert-icon"><i class="flaticon-warning"></i></div>
                <div class="alert-text">{{ error }}</div>
                <div class="alert-close">
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true"><i class="la la-close"></i></span>
                  </button>
                </div>
              </div>
            </template>

            <div class="kt-portlet__body app_service__form-body">
              <div class="row">
                <div class="col-xl-3"></div>
                <div class="col-xl-6">

                  <div v-if="errorsList">
                    <div class="alert alert-warning" role="alert" v-for="error in errorsList">
                      Ошибка: {{error}}
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Список ID администраторов приложения:</label>
                    <input type="text" v-model="value" name="admins" class="form-control"
                           placeholder="Введите ID через запятую">
                  </div>

                  <table class="app__access-table" v-if="false">
                    <tr v-for="admin in adminsList" v-bind:key="admin.ID">
                      <td class="app__access-table--name">
                        {{ admin.NAME }}
                        {{ admin.LAST_NAME }}
                      </td>
                      <td class="app__access-table--ability">
                        <template v-if="admin.editable">
                          <vSelect
                            class="app__vue-select"
                            :options="accessList"
                            v-on:input="setAccess($event, right)"
                            :value="right.access"
                            :placeholder="$t('Пользователь...')"/>

                          <a href="javascript:void(0)" v-if="right.removable"
                             v-on:click="removeRight(right)">
                            <i class="flaticon-delete"></i>
                          </a>
                        </template>
                        <template v-else-if="admin.creator">
                          Создатель
                        </template>
                        <template v-else-if="admin.current">
                          Это вы
                        </template>
                        <template v-else>
                          Нельзя отредактировать
                        </template>
                      </td>
                      <td class="app__access-table--actions">
                        <a href="javascript:void(0)"
                           v-if="right.removable && right.edit"
                           v-on:click="removeRight(right)">
                          <i class="flaticon-delete"></i>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td></td>
                      <td colspan="2">
                        <a href="javascript:void(0)" v-on:click="addRight">
                          <i class="la la-plus"></i>
                          {{$t('Добавить')}}
                        </a>
                      </td>
                    </tr>
                  </table>

                </div>
                <div class="col-xl-3"></div>
              </div>
            </div>

            <div class="kt-portlet__foot">
              <div class="kt-form__actions">
                <div class="row">
                  <div class="col-xl-3"></div>
                  <div class="col-xl-6">

                    <div v-if="errorsList">
                      <div class="alert alert-warning" role="alert" v-for="error in errorsList">
                        Ошибка: {{error}}
                      </div>
                    </div>

                    <button type="submit" class="btn btn-brand app__btn">
                      Сохранить
                    </button>&nbsp;
                    <router-link :to="{name: 'home'}" class="btn btn-secondary app__btn">
                      Отменить
                    </router-link>
                  </div>
                  <div class="col-xl-3"></div>
                </div>
              </div>
            </div>
          </form>
          <!--end::Form-->
        </div>
      </div>
      <!--[html-partial:include:{"file":"partials\/_footer-base.html"}]/-->
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select';
import Loading from '../components/Loading';
import Api from '../Api';

import 'vue-select/src/scss/vue-select.scss';

export default {
  name: 'SettingsApp',
  data() {
    return {
      value: '',
      loading: false,
      errorsList: [],
      criticalErrorsList: [],
      adminsList: [],
    };
  },
  components: {
    Loading,
    vSelect,
  },
  computed: {
    hasError() {

    },
  },
  methods: {
    startLoading() {
      this.loading = true;
    },
    stopLoading() {
      this.loading = false;
      window.BX24.ready(() => {
        window.BX24.init(() => {
          const height = document.getElementById('content-portlet').clientHeight;
          window.BX24.resizeWindow(
            document.body.clientWidth,
            height + 150,
          );
        });
      });
    },
    saveSettings() {
      this.startLoading();

      const data = {};
      data.admins = this.value;
      const request = Api.saveSettings(data);
      request.then((response) => {
        console.log(response);
      });

      request.catch((error) => {
        console.log(error);
      });

      request.finally(() => {
        this.fetchData();
      });
    },
    addUser() {

    },
    fetchData() {
      this.startLoading();
      const request = Api.getSettings();
      request.then((response) => {
        console.log(response);
        if (response.data.errors && response.data.errors.length > 0) {
          response.errors.forEach((el) => {
            this.criticalErrorsList.push(el);
          });
        } else {
          this.adminsList = response.data.adminsList;
          if (this.adminsList && this.adminsList.length > 0) {
            this.value = '';
            const userIDs = [];
            this.adminsList.forEach((el) => {
              userIDs.push(el.ID);
            });
            this.value = userIDs.join(',');
            console.log(userIDs);
            console.log(this.value);
          }
        }
      });

      request.catch((error) => {
        this.criticalErrorsList.push('Ошибка получения настроек');
      });

      request.finally(() => {
        this.stopLoading();
      });
    },
  },
  created() {
    this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
};
</script>

<style lang="scss">
  #kt_content {
    color: #000;
    font-family: "Roboto", serif;
  }

  .app__portlet-head {
    font-family: "Roboto", serif;
  }

  .kt-portlet__head-title {
    font-family: "Roboto", serif;
  }

  .app__portlet-head {
    font-family: "Roboto", serif;
  }

  .app_service__form-body {
    font-family: "Roboto", serif;

    fieldset {
      max-width: 900px;
      margin: 0 auto;
    }
  }
</style>
